import { CamelcasePipe } from './../../pipes/camelcase.pipe';
import { AfterViewInit, Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { SnackService } from '../../service/snack.service';
import { FormBuilder } from '@angular/forms';
import { StreamService } from '../../service/stream.service';
import { AiService } from '../../service/ai.service';
import { UserdataService } from '../../service/userdata.service';
import { MatDialog } from '@angular/material/dialog';
import { EasyTwoPopupComponent } from './easy-two-popup/easy-two-popup.component';
import { Easy2Service } from '../../service/easy2.service';
import { InternLandingPageComponent } from '../intern-landing-page/intern-landing-page.component';
import { appurl } from '../../../environments/environment';
import { TrackService } from '../../service/track.service';
import { Track } from '../../interfaces/trackdata';
import { ResultPreviewComponent } from '../../home/user/stream-dashboard/result-preview/result-preview.component';
import { StepResult } from '../../interfaces/responsedata.ts/trackresults';
import { GreetingDialogComponent } from './greeting-dialog/greeting-dialog.component';
import { ClipboardService } from '../../service/clipboard.service';

@Component({
    selector: 'app-closing-stream-view',
    standalone: false,
    providers: [CamelcasePipe],
    templateUrl: './closing-stream-view.component.html',
    styleUrl: './closing-stream-view.component.scss'
})
export class ClosingStreamViewComponent implements OnChanges, AfterViewInit {
    // Injections
    trackService = inject(TrackService);
    snack = inject(SnackService);
    fb = inject(FormBuilder);
    aiService = inject(AiService);
    camelCasePipe = inject(CamelcasePipe);
    user = inject(UserdataService);
    dialog = inject(MatDialog);
    easy2Service = inject(Easy2Service);
    clipboardService = inject(ClipboardService);

    // Inputs
    @Input({ required: true }) streamId: string = "";
    @Input({ required: true }) stepId: string = "";
    @Input({ required: true }) roundId: string = "";
    @Input({ required: true }) initialReady: boolean = false;
    @Input({ required: true }) currentTrackData: Track | undefined;
    @Input({ required: true }) currentTrackName: string = "";
    @Input() industryTypeId: string = "";
    @Input() businessTypeId: string = "";
    @Input() ideaTypeId: string = "";
    @Input() lpReferenceId: string | null = null;

    // Outputs
    @Output() goToValidation = new EventEmitter<void>();

    // Variables
    readonly appurl = appurl
    userId: string = ""
    link: string = "";
    showspinner: boolean = false;
    loadingLandingPage: boolean = false;
    landingPageStep = 0;
    landingPageLink = "";

    // Objects
    adresses = this.fb.control('')
    closingOptions: any[] = [];
    reports: any[] = [];
    files: any[] = [];
    results: any[] = [];
    resultListToShow: any[] = [];
    streamDescription: string = '';

    constructor(
        private streamService: StreamService,
    ) {
        this.link = window.location.href;
        this.userId = this.user.data.getValue()!.id
        // let easyTwoLink = this.user.data.getValue().easyTwoLink;
        // if (easyTwoLink) {
        //   this.landingPageStep = 10;
        //   this.landingPageLink = easyTwoLink;
        // }


    }

    ngAfterViewInit(): void {
        // get "greetingShown" from localStorage
        const greetingShown = localStorage.getItem('ids-greetingShown');
        if (!greetingShown) {
            localStorage.setItem('ids-greetingShown', 'true');
            this.dialog.open(GreetingDialogComponent, {
                panelClass: "small-dialog",

            });
        }
    }
    async generatePageLink(): Promise<boolean> {
        let refId = await this.trackService.generateLpLink(this.roundId);
        if (refId === false) return false;
        this.lpReferenceId = refId;

        this.landingPageLink = `${appurl}/projectpage?pid=${this.lpReferenceId}`;
        return true;
    }
    async ngOnChanges(changes: SimpleChanges): Promise<void> {

        if (changes["initialReady"] && changes["initialReady"].currentValue === true) {

            this.currentTrackData?.streams.forEach(async (stream) => {
                let res = await this.getClosingOptionsByStreamId(stream.id);
                this.closingOptions.push(...res);
            });

            let results = this.trackService.trackResults.getValue();

            let streamresults = results.find((r) => r.streamId === this.streamId)?.stepResults;
            if (streamresults) this.results = streamresults;

            // console.log("TrackData", this.currentTrackData);
            // console.log("Results", this.results);

            let stream =  results.find((r) => r.streamId == "J1S-8At2nL")?.stepResults;
            let basic_idea = stream?.find(s => s.stepId === "MMUT2vQla")?.result;
            this.streamDescription = basic_idea?.['value_proposition'] ?? ''

            let lp =  results.find((r) => r.streamId == "export_reports")?.stepResults;
            if (lp) {
                let lpData = lp.find((step) => step.stepId === "landingPage")?.result;
                this.landingPageLink = lpData?.['link'] ?? null;
            }
        }
    }
    async getClosingOptionsByStreamId(streamId: string): Promise<any[]> {
        this.showspinner = true;
        let result = await this.streamService.getClosingOptionsByStreamId(streamId);
        this.showspinner = false;
        if (result === false) return [];

        let option = []

        for (let i = 0; i < result.length; i++) {
            const transformedName = this.camelCasePipe.transform(result[i].promptType.replace('OUTPUT_', '').replace(/_/g, " "));
            option.push({
                streamId: streamId,
                name: transformedName,
                type: result[i].promptType,
                id: result[i].id,
                outputType: result[i].outputType,
                orderNr: result[i].orderNr,
                loading: false
            });

        }
        return option;
    }
    async generateInternLandingPage() {
        console.log("Generating intern landing page...");

        let idea_summary = await this.results?.find((b: any) => b.stepId == 'MMUT2vQla'); // Basic Idea
        let primary_persona = await this.results?.find((b: any) => b.stepId == 'Ci6Ju_grd'); // User Tinder
        let core_problem = await this.results?.find((b: any) => b.stepId == 'jKHo2wIzi'); // User Insight Mapping

        if (!idea_summary || !primary_persona || !core_problem) {
            // if (!idea_summary || !primary_persona || !core_problem || !solution_approach) {
            this.snack.error({ error: { msg: { "headline": "Error", "text": "One of the required steps is missing. Try to reload the page." } } });
            return;
        }

        let userInput = "";

        if (idea_summary) userInput += `<idea summary>\n${JSON.stringify(idea_summary)}\n\n`;
        if (primary_persona) userInput += `<primary persona>\n${JSON.stringify(primary_persona)}\n\n`;
        if (core_problem) userInput += `<core problem>\n${JSON.stringify(core_problem)}\n\n`;
        // if (solution_approach) userInput += `<solution approach>\n${JSON.stringify(solution_approach)}\n\n`;

        this.loadingLandingPage = true;
        let result = await this.aiService.getAiStandaloneResponse("CREATE_LP_DATA_INTERN", userInput, this.roundId);
        this.loadingLandingPage = false;

        if (result !== false) {
            await this.generatePageLink();
            this.trackService.addStepResult(this.roundId, "export_reports", "landingPage", { "generated": true, "link": this.landingPageLink }, "Landing Page");
        }

    }
    async openSource(target: StepResult): Promise<void> {
        // console.log(target);
        if (!target.result["name"] && target.name) {
            if (typeof target.result === 'string') {
                target.result = {}
            }
            target.result["name"] = target.name;
        }

        let dia = this.dialog.open(ResultPreviewComponent, {
            data: target.result,
            disableClose: true,
            autoFocus: false,
        });

        dia.afterClosed().subscribe(async (result: any) => {
            if (!result) return;
            target.result = result.resultData;
            this.trackService.saveResult(this.roundId, this.streamId, target);

            if (result?.type === "download-pdf") {
                let type = target.name.toLowerCase().replace(/\s+/g, '_');
                this.showspinner = true;
                let file = await this.trackService.createFileFromResultData(this.roundId, target.result['name'], result.resultData, type, target.stepId, this.streamId);
                this.showspinner = false;
                if (file === false) return;

                target.file = {
                    "id": file.id,
                    "fileName": file.identifer,
                    "fileSize": file.size,
                    "dateCreated": new Date().getTime()
                };
                this.showspinner = true;
                this.trackService.downloadTrackResultFile(this.roundId, target.file.id, target.file.fileName)
                this.showspinner = false;
            }
        });

    }
    async downloadSource(type: any) {
        console.log("TYPE", type);

        let r = await this.files.find((file) => file.fileType.toLowerCase() === type.type.toLowerCase());
        if (r) {
            if (r.userId !== this.userId && r.projectOwnerId !== this.userId) {
                this.snack.info({ msg: { headline: "Download not allowed", text: 'You are not allowed to download this file!' }, type: "info" });
                console.log('You are not allowed to download this file');
                return;
            }
            this.showspinner = true;
            let f = await this.streamService.downloadTrackResultFile(this.roundId, r.id, r.fileName)
            this.showspinner = false;
            return;
        }

        let idea_summary = await this.results?.find((b: any) => b.stepId == 'MMUT2vQla'); // Basic Idea
        let primary_persona = await this.results?.find((b: any) => b.stepId == 'Ci6Ju_grd'); // User Tinder
        let core_problem = await this.results?.find((b: any) => b.stepId == 'jKHo2wIzi'); // User Insight Mapping

        if (!idea_summary || !primary_persona || !core_problem) {
            this.snack.error({ error: { msg: { "headline": "Error", "text": "One of the required steps is missing. Try to reload the page." } } });
            return;
        }

        let userInput = "<USER CONTENT>";

        if (idea_summary) userInput += `<idea summary>\n${JSON.stringify(idea_summary)}\n\n`;
        if (primary_persona) userInput += `<primary persona>\n${JSON.stringify(primary_persona)}\n\n`;
        if (core_problem) userInput += `<core problem>\n${JSON.stringify(core_problem)}\n\n`;

        this.showspinner = true;
        let result = await this.aiService.getAiResponse(type.streamId, type.id, userInput, type.type, type.orderNr, this.roundId);
        this.showspinner = false;

        result.promptResult[0].name = type.name;


        let dia = this.dialog.open(ResultPreviewComponent, {
            data: result.promptResult[0]
        });
        dia.afterClosed().subscribe(async (result: any) => {

            await this.trackService.addStepResult(this.roundId, "export_reports", type.id, result.promptResult[0], type.name);

            if (result?.type === "download-pdf") {
                this.showspinner = true;
                let file = await this.trackService.createFileFromResultData(this.roundId, type.name, result.promptResult[0], type.type, this.stepId, this.streamId);
                this.showspinner = false;
                if (file === false) return;

                let item = {
                    "id": file.id,
                    "fileName": file.identifer,
                    "fileSize": file.size,
                    "dateCreated": new Date().getTime()
                };
                this.showspinner = true;
                this.trackService.downloadTrackResultFile(this.roundId, item.id, item.fileName)
                this.showspinner = false;
            }
        });
    }
    async copyToClipboard(link: string) {
        await this.clipboardService.copyToClipboard(link);
    }
    sendLinkToAdresses() {
        if (this.adresses.valid === false || this.adresses.value == '' || !this.adresses.value) return;

        const adressesArray = this.adresses.value.split(',').map((item: string) => item.trim());
        console.log(this.adresses.valid, adressesArray);

    }
    transformOptionName(optionName: string): string {
        return this.camelCasePipe.transform(optionName);
    }
    async openInternLandingPage() {
        let dia = this.dialog.open(InternLandingPageComponent, {
            panelClass: "feed-back-card",
            data: { projectId: this.lpReferenceId }
        });
    }
    async openEasyTwoDialog() {
        let dia = this.dialog.open(EasyTwoPopupComponent, {
            width: '500px'
        });
        dia.afterClosed().subscribe(async (res) => {
            if (res.data) {
                await this.onCreateLandingPage()
            }
        })
    };
    async onCreateLandingPage() {
        this.landingPageStep = 2;
        let accountResult: any = await this.easy2Service.checkAndCreateAccount(
            this.user.data!.getValue()!.email!,
            this.user.data!.getValue()!.projectData?.own[0].projectId
        );
        if (accountResult === false || !accountResult.link) {
            console.log(accountResult)
            this.landingPageStep = -1;
            return;
        }
        this.landingPageLink = accountResult.link;
        this.landingPageStep = 3;
        let landingPageResult: any = await this.easy2Service.createLandingPage();
        if (landingPageResult === false) {
            this.landingPageStep = -1;
            return;
        }
        this.landingPageStep = 4;
    }
}
